// @ts-check
import "./App.css";
import { Footer } from "./components/Footer";
// import { Header } from "./components/Header";

export function App({ content }) {
  return (
    <>
      {/* <Header /> */}
      {content}
      <Footer />
    </>
  );
}
